<template>
    <div class="bg-white shadow-md rounded">
        <div class="relative" v-show="!initial">
            <slot :toggle="toggle" :active="active" />

            <transition name="fade">
                <slot name="items" :active="active" />
            </transition>
        </div>

        <div v-if="loading" v-bind:class="{'relative': initial}">
            <div class="box__loading p-6">
                <app-loader />
            </div>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/Loader';

export default {
    name: 'app-tabs-wrapper',

    components: {
        'app-loader': Loader
    },

    props: {
        default: String,
        loading: {
            type: Boolean, 
            required: false
        },
        initial: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        active: ''
    }),

    mounted() {
        this.active = this.default ? this.default : '';
    },

    methods: {
        toggle(name) {
            this.active = name;
        },

        close() {
            this.active = '';
        },
    },
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/tabs/Wrapper.vue